<!-- Template for a new page -->
<template>
	<div class="d-flex flex-column flex h-100">
		<navbar></navbar>
		<div class="app">
			<reporting-sidenav></reporting-sidenav>
			<div id="content" class="app-content box-shadow-3 d-flex flex flex-column scroll-x">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-light b-b flex-nowrap no-grow">
					<div class="navbar-text nav-title flex" id="pageTitle">
						Reporting
						<span class="far fa-fw fa-angle-right"></span>Completion
					</div>
					<div class="checkbox mr-3">
						<label class="md-check">
							<input v-model="showUnused" type="checkbox" />
							<i class="theme-accent"></i>
							Show Unused
						</label>
					</div>
					<div class="float-right navbar-text pointer" @click="init()">
						<i class="far fa-sync-alt"></i>
					</div>
				</div>

				<div class="flex d-flex flex-row scroll-x scroll-y">
					<div class="flex">
						<div class="row mx-4">
							<div class="align-self-stretch col-6 py-3">
								<div class="h-100 box-shadow-heavy card theme">
									<div class="card-body d-flex flex-row align-items-center">
										<h4 class="mb-0 mr-1">
											<i class="fas fa-fw fa-inventory mr-2"></i>
										</h4>
										<div class="text-center">
											<h4 class="mb-0 d-inline-block">
												<span>Responses:</span>
												<loading type="icon" v-if="loading" />
												<span v-if="!loading">{{ overall.total.toLocaleString() }}</span>
											</h4>
										</div>
									</div>
								</div>
							</div>
							<div class="align-self-stretch col-6 py-3">
								<div class="h-100 box-shadow-heavy card theme">
									<div class="card-body d-flex flex-row align-items-center">
										<h4 class="mb-0 mr-1">
											<i class="fas fa-fw fa-badge-check mr-2"></i>
										</h4>
										<div class="text-center">
											<h4 class="mb-0 mr-1 d-inline-block">
												<span>Complete:</span>
												<loading type="icon" v-if="loading" />
												<span v-if="!loading">{{ overall.complete.toLocaleString() }}</span>
											</h4>
											<h5 class="mb-0 d-inline-block">
												<span v-if="!loading" class="text-muted"
													>({{
														((overall.complete * 100) / overall.total).toFixed(0)
													}}%)</span
												>
											</h5>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class>
							<div
								v-for="(ca, i) in stats"
								:key="ca.id"
								class="mx-3 box"
								:class="{ 'mb-1': determineCardMargin(stats, i) }"
							>
								<div class="d-flex flex-row">
									<div class="flex justify-content-start align-self-center ml-2">
										<a @click="toggleCollapse(ca.id)">
											<i
												class="fas fa-lg fa-angle-down anim-rotate"
												:class="{ 'rotate-180': collapsed[ca.id] }"
											></i>
										</a>
									</div>
									<label
										class="flex d-flex justify-content-center align-self-center black-text my-1 _600 text-theme"
										>{{ ca.name }}</label
									>

									<div class="flex d-flex justify-content-end">
										<!-- <a
											v-if="!collapsed[ca.id]"
											class="btn-subtle my-1 mx-2"
											v-tippy
											title="Export..."
											data-toggle="dropdown"
											aria-expanded="false"
										>
											<i class="fas fa-file-export" style="margin-left: 2px;"></i>
										</a>
										<div class="dropdown-menu dropdown-menu-right w">
											<a class="dropdown-item" @click="dlPdf()">
												<i class="far fa-file-pdf fa-fw fa-lg"></i>
												<label class="mb-0">Export to PDF</label>
											</a>
											<a class="dropdown-item" @click="dlCsv()">
												<i class="far fa-file-excel fa-fw fa-lg"></i>
												<label class="mb-0">Export to CSV</label>
											</a>
										</div>-->
									</div>
								</div>

								<div v-if="!collapsed[ca.id]" class>
									<table class="table condensed-table" style="display: block;">
										<thead v-if="!loading">
											<tr>
												<th>
													<div class="t-margin p-custom"></div>
												</th>
												<th style="width: 16px"></th>
												<th></th>
												<th style="width: 14%" class="ar d-long">Total</th>
												<th style="width: 14%" class="ar d-abr" v-tippy title="Total">Tot</th>
												<th style="width: 14%" class="ar d-long">Unscored</th>
												<th style="width: 14%" class="ar d-abr" v-tippy title="Unscored">
													Unsc
												</th>
												<th style="width: 14%" class="ar d-long">Scored Once</th>
												<th style="width: 14%" class="ar d-abr" v-tippy title="Scored Once">
													Once
												</th>
												<th style="width: 14%" class="ar d-long">Resolution</th>
												<th style="width: 14%" class="ar d-abr" v-tippy title="Resolution">
													Res
												</th>
												<th style="width: 14%" class="ar d-long">Complete</th>
												<th style="width: 14%" class="ar d-abr" v-tippy title="Complete">
													Comp
												</th>
												<th
													style="width: 28%"
													class="ar d-long"
													v-tippy
													title="Resolution Required"
												>
													Res. Required
												</th>
												<th
													style="width: 14%"
													class="ar d-abr"
													v-tippy
													title="Resolution Required"
												>
													Res Req
												</th>
												<th>
													<div class="t-margin p-custom"></div>
												</th>
											</tr>
										</thead>
										<tbody v-if="loading">
											<tr>
												<td colspan="10">
													<loading type="table" />
												</td>
											</tr>
										</tbody>
										<tbody v-if="!loading">
											<tr class="theme-lighten-3 text-on-color">
												<td class="t-margin p-custom"></td>
												<td colspan="2">Totals</td>
												<td class="ar">{{ ca.totals.total }}</td>
												<td class="ar">{{ ca.totals.unscored }}</td>
												<td class="ar">{{ ca.totals.reliability }}</td>
												<td class="ar">{{ ca.totals.resolution }}</td>
												<td class="ar">
													{{ ca.totals.complete }}
													<span class="text-muted text-xs"
														>({{ pcr(ca.totals.complete, ca.totals.total) }}%)</span
													>
												</td>
												<td class="ar">
													{{ ca.totals.resolution_complete + ca.totals.resolution }}
													<span class="text-muted text-xs">
														({{
															pcr(
																ca.totals.resolution_complete + ca.totals.resolution,
																ca.totals.complete + ca.totals.resolution
															)
														}}%)
													</span>
												</td>
												<td class="t-margin p-custom"></td>
											</tr>
										</tbody>
										<tbody v-if="!loading" v-for="grade in ca.grades" :key="grade.id">
											<tr class="theme-lighten-5 text-on-color">
												<td class="t-margin p-custom"></td>
												<td colspan="2">
													<div v-tippy :title="grade.name" class="grade-name">
														{{ grade.name }}
													</div>
												</td>
												<td class="ar d-long">Total</td>
												<td class="ar d-abr" v-tippy title="Total">Tot</td>
												<td class="ar d-long">Unscored</td>
												<td class="ar d-abr" v-tippy title="Unscored">Unsc</td>
												<td class="ar d-long">Scored Once</td>
												<td class="ar d-abr" v-tippy title="Scored Once">Once</td>
												<td class="ar d-long">Resolution</td>
												<td class="ar d-abr" v-tippy title="Resolution">Res</td>
												<td class="ar d-long">Complete</td>
												<td class="ar d-abr" v-tippy title="Complete">Comp</td>
												<td class="ar d-long" v-tippy title="Resolution Required">
													Res. Required
												</td>
												<td class="ar d-abr" v-tippy title="Resolution Required">Res Req</td>
												<td class="t-margin p-custom"></td>
											</tr>
											<tr v-for="asmt in grade.assessments" :key="asmt.id">
												<td class="t-margin p-custom"></td>
												<td class="ar text-center theme-hover-lighten-7"></td>
												<td>
													<div v-tippy :title="asmt.name" class="asmt-name">
														{{ asmt.name }}
													</div>
												</td>
												<td
													class="ar"
													@click="cellClick(asmt.id, 0)"
													:class="{ 'clickable theme-hover-lighten-7': canLink }"
												>
													<a>{{ asmt.total }}</a>
												</td>
												<td
													class="ar"
													@click="cellClick(asmt.id, 1)"
													:class="{ 'clickable theme-hover-lighten-7': canLink }"
												>
													<a>{{ asmt.unscored }}</a>
												</td>
												<td
													class="ar"
													@click="cellClick(asmt.id, 2)"
													:class="{ 'clickable theme-hover-lighten-7': canLink }"
												>
													<a>{{ asmt.reliability }}</a>
												</td>
												<td
													class="ar"
													@click="cellClick(asmt.id, 3)"
													:class="{ 'clickable theme-hover-lighten-7': canLink }"
												>
													<a>{{ asmt.resolution }}</a>
												</td>
												<td
													class="ar"
													@click="cellClick(asmt.id, 10)"
													:class="{ 'clickable theme-hover-lighten-7': canLink }"
												>
													<a>
														{{ asmt.complete }}
														<span class="text-muted text-xs"
															>({{ pcr(asmt.complete, asmt.total) }}%)</span
														>
													</a>
												</td>
												<td
													class="ar"
													@click="cellClick(asmt.id, 0, 3)"
													:class="{ 'clickable theme-hover-lighten-7': canLink }"
												>
													<a>
														{{ asmt.resolution_complete + asmt.resolution }}
														<span class="text-muted text-xs"
															>({{
																pcr(
																	asmt.resolution_complete + asmt.resolution,
																	asmt.complete + asmt.resolution
																)
															}}%)</span
														>
													</a>
												</td>
												<td class="t-margin p-custom"></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ar {
	text-align: right;
}
table {
	table-layout: fixed;
}
.grade-name {
	width: 340px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.asmt-name {
	width: 324px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.asmt-margin {
	width: 15px;
}
table a {
	cursor: default;
}
.clickable {
	color: #000;
	cursor: pointer;
	transition: background-color 0.15s;
}
.clickable:hover {
	color: inherit;
	text-decoration-line: underline;
}
.d-long {
	display: none;
}
.d-abr {
	display: table-cell;
}
@media (min-width: 1200px) {
	.d-long {
		display: table-cell;
	}
	.d-abr {
		display: none;
	}
}
.table td,
.table th {
	white-space: nowrap;
}
.table td:not(.t-margin),
.table th:not(.t-margin) {
	padding: 0.15rem 0.25rem !important;
}
.t-margin {
	width: 8px;
	padding: 0 !important;
}
.mw-100 {
	min-width: 100%;
}
.anim-rotate {
	transition: transform 0.2s ease-out;
}
.rotate-180 {
	transform: rotate(-180deg);
}
.btn-subtle {
	opacity: 0.21;
	transition: opacity 0.25s;
}
.btn-subtle:hover {
	opacity: 0.6;
}
</style>

<script>
//Libraries

//Services
import ReportingService from "@/services/ReportingService";
import notie from "@/services/NotieService";
import store from "@/services/Store";
//import FileService from "@/services/FileService";

export default {
	name: "ReportCompletion",

	props: ["user"],

	data() {
		return {
			stats: null,
			overall: null,
			collapsed: store.getDefault(this, "completion.collapsed", {}),
			showUnused: store.getDefault(this, "completion.showUnused", false),

			loading: true
		};
	},

	computed: {
		canLink() {
			return this.user.role.page_auditing;
		},

		caList() {
			let list = [];
			_.each(this.contentAreas, (name, id) => {
				list.push({ name: name, id: id });
			});

			return _.sortBy(list, "name");
		}
	},

	watch: {
		collapsed: {
			handler: function() {
				store.set(this, "completion.collapsed", this.collapsed);
			},
			deep: true
		},
		showUnused() {
			store.set(this, "completion.showUnused", this.showUnused);
			this.init();
		}
	},

	created() {
		this.init();
	},

	methods: {
		init() {
			this.loading = true;
			ReportingService.getCompletionStats(this.showUnused)
				.then(resp => {
					this.stats = resp.data.statTree;
					this.overall = resp.data.overall;
				})
				.catch(err => {
					notie.error("Failed to load completion stats", err);
				})
				.finally(() => {
					this.loading = false;
				});
		},

		pcr(num, den) {
			if (den == 0) {
				return "-";
			}
			if (num == 0) {
				return "0.00";
			}

			var res = (num / den) * 100;
			return res.toFixed(1);
		},

		// dlPdf() {
		// 	FileService.completionReportPDF(this.user, this.pcr);
		// },

		// dlCsv() {
		// 	FileService.completionReportCSV(this.user, this.pcr);
		// },

		toggleCollapse(id) {
			this.$set(this.collapsed, id, !this.collapsed[id]);
		},

		determineCardMargin(list, i) {
			let curr = list[i];
			let next = list[i + 1];

			if (!next || (this.collapsed[curr.id] && this.collapsed[next.id])) {
				return true;
			} else {
				return false;
			}
		},

		cellClick(assessmentID, state, hasScore, flagged, reviewed) {
			if (!this.canLink) {
				//Prevent linking if the user doesn't have requisite permission to follow the link
				return;
			}

			store.set(this, "audit.r.teacher", null);
			store.set(this, "audit.r.selectedCA", null);
			store.set(this, "audit.r.selectedGrade", null);
			store.set(this, "audit.r.response_id", "");
			store.set(this, "audit.r.users", []);
			store.set(this, "audit.r.trait_scores", []);
			store.set(this, "audit.r.score_specific_query", false);
			if (hasScore) {
				store.set(this, "audit.r.filter_types", [{ type: hasScore }]);
			} else {
				store.set(this, "audit.r.filter_types", []);
			}

			store.set(this, "audit.r.selectedAsmt", { id: assessmentID });
			store.set(this, "audit.r.selectedState", { value: state });

			this.$router.push("/auditing");
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/QualityMgmt/ReportCompletion.vue